import { render } from "./CommercialBookingForm.vue?vue&type=template&id=71b32930"
import script from "./CommercialBookingForm.vue?vue&type=script&lang=js"
export * from "./CommercialBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__